import { render, staticRenderFns } from "./ThankView.vue?vue&type=template&id=4ed3962a&scoped=true&"
import script from "./ThankView.vue?vue&type=script&lang=js&"
export * from "./ThankView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed3962a",
  null
  
)

export default component.exports